if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const mainVariantId = formData.get('id');
        const bundleVariantId = (this.dataset.bundleVariantId || '').trim();
        const shouldBundle = bundleVariantId && bundleVariantId !== String(mainVariantId);

        const buildMainItem = () => {
          const item = {
            id: mainVariantId,
            quantity: Number(formData.get('quantity') || 1),
          };
          const sellingPlan = formData.get('selling_plan');
          if (sellingPlan) item.selling_plan = sellingPlan;

          const properties = {};
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match) properties[match[1]] = value;
          });
          if (Object.keys(properties).length) item.properties = properties;
          return item;
        };

        const addBundleWithSections = () => {
          const parentTitle = (this.dataset.bundleParentTitle || '').trim();
          const bundleProperties = {};
          if (parentTitle) {
            bundleProperties['小物セット対象'] = `${parentTitle} (${mainVariantId})`;
          } else {
            bundleProperties['小物セット対象'] = String(mainVariantId);
          }
          bundleProperties['_bundle_target_id'] = String(mainVariantId);

          const items = [
            buildMainItem(),
            {
              id: bundleVariantId,
              quantity: 1,
              properties: bundleProperties,
            },
          ];
          const body = JSON.stringify({ items });
          const bundleConfig = fetchConfig();
          bundleConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          bundleConfig.body = body;

          const verifyBundleVariant = () => {
            return fetch(`/variants/${bundleVariantId}.js`)
              .then((response) => {
                if (!response.ok) {
                  throw new Error(
                    `指定のVariant IDが無効か非公開です。(status ${response.status})`
                  );
                }
                return response.json();
              });
          };

          return verifyBundleVariant()
            .then(() => fetch(`${routes.cart_add_url}.js`, bundleConfig))
            .then(async (response) => {
              if (!response.ok) {
                let message = `cart_add_failed (status ${response.status})`;
                const responseClone = response.clone();
                let errorPayload = null;
                try {
                  errorPayload = await responseClone.json();
                } catch (e) {}
                if (errorPayload) {
                  message =
                    errorPayload?.description ||
                    errorPayload?.message ||
                    `${message}: ${JSON.stringify(errorPayload).slice(0, 200)}`;
                } else {
                  try {
                    const errorText = await response.text();
                    if (errorText) {
                      message = `${message}: ${errorText.slice(0, 160)}`;
                    }
                  } catch (e2) {}
                }
                throw new Error(message);
              }
              return response.json();
            })
            .then(() => {
              if (!this.cart) {
                window.location = window.routes.cart_url;
                return null;
              }
              const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
              const url = `${window.routes.cart_url}?sections=${sectionIds.join(',')}`;
              return fetch(url)
                .then((response) => response.json())
                .then((sections) => {
                  this.cart.setActiveElement(document.activeElement);
                  this.cart.renderContents({
                    id: mainVariantId,
                    sections,
                  });
                  return { sections };
                });
            });
        };

        if (shouldBundle) {
          addBundleWithSections()
            .then(() => {
              this.error = false;
            })
            .catch((error) => {
              this.error = true;
              this.handleErrorMessage(error?.message || window.cartStrings.error);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
              CartPerformance.measureFromEvent("add:user-action", evt);
            });
          return;
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
